import apiFetch from './client';

export function getExercises(filters = {}) {
  const params = new URLSearchParams();
  if (filters.tag_id) params.append('tag_id', filters.tag_id);
  const qs = params.toString();
  return apiFetch(`/api/exercises/${qs ? '?' + qs : ''}`);
}

export function getExercise(id) {
  return apiFetch(`/api/exercises/${id}`);
}

export function createExercise(data) {
  return apiFetch('/api/exercises/', { method: 'POST', body: JSON.stringify(data) });
}

export function updateExercise(id, data) {
  return apiFetch(`/api/exercises/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

export function deleteExercise(id) {
  return apiFetch(`/api/exercises/${id}`, { method: 'DELETE' });
}

export function importExercise(id) {
  return apiFetch(`/api/exercises/${id}/import`, { method: 'POST' });
}
